import React from "react";
import { formatPrice } from "../../utils/formatPrice";

function CartSummary({ categorizedCart, config }) {
  const fieldTTC = config?.itemPriceFieldTTC ?? "Prix de vente TTC";
  return (
    <div className="space-y-6">
      {Object.entries(categorizedCart).map(([category, items]) =>
        items.length > 0 ? (
          <div key={category}>
            <h3 className="font-semibold text-left text-md md:text-lg text-black mb-2">
              {category}
            </h3>
            <div className="space-y-2">
              {items.map((item) => (
                <div
                  key={item.meal.id}
                  className="flex justify-between text-md md:text-lg font-light text-start"
                >
                  <div>
                    {item.quantity} x {item.meal.fields["Name"]}
                  </div>
                  <div className="flex items-center min-w-fit">
                    {formatPrice(
                      item.quantity * item.meal.fields[fieldTTC]
                    )}{" "}
                    €
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null
      )}
    </div>
  );
}

export default CartSummary;
